import { KeyValue } from '@angular/common';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  ViewChild,
  ChangeDetectionStrategy,
} from '@angular/core';
import { FloatLabelType } from '@angular/material/form-field';

@Component({
  selector: 'lib-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class SelectComponent implements OnInit, OnChanges {
  @Input() options: SelectionOption[] = [];
  @Input() groups: Record<string, { key: string; value: string; obj: any }[]>;
  @Input() value;
  @Input() errors;
  @Input() disabled = false;
  @Input() dropdownIconsPath: string;
  @Input() translation: boolean;
  @Input() translationPrefix: string;
  @Input() placeholder = 'global.select';
  @Input() customPanelClass: string;
  @Input() noInfix = false;
  @Input() withTrigger = false;
  @Input() stayOpenAfterPick = false;
  @Input() multiSelectMode = false;
  @Input() optionImgWidth = '30px';
  @Input() noBackground = false;
  @Input() noUnderline = true;
  /** Ellipsize a long selected value instead of letting it run under the dropdown arrow. */
  @Input() truncateValue = false;
  @Input() label = null;
  @Input() requiredInLabel = false;
  @Input() translateLabel = false;
  @Input() required = false;
  @Input() offsetToLeft = false;
  @Input() myFloatLabel: FloatLabelType | 'never';
  @Input() theme: 'dark' | 'light' = 'light';
  @Input() sortMode = false;
  @Input() isSortAscending = true;
  @Input() deselectMode = false;
  @Input() resetOnSelect = false;
  @Input() selectedIds: any[] | null = null;
  @Output() valueChange: EventEmitter<any> = new EventEmitter<any>();
  @Output() openedChange = new EventEmitter<boolean>();
  @Output() isAscendingChange = new EventEmitter<boolean>();
  isContentProjected = true;
  // Width of the option rows, taken once when the panel opens. Reading getBoundingClientRect() straight from
  // the template re-measured on every check and tripped NG0100 under Angular 19.
  optionWidth: number | null = null;
  @ViewChild('mffContainer', { read: ElementRef }) mffContainer: ElementRef<HTMLElement>;

  constructor(
    private cdr: ChangeDetectorRef,
    private elementRef: ElementRef
  ) {}

  ngOnInit(): void {}

  ngOnChanges() {
    this.cdr.detectChanges();
  }

  onOpenedChange(event) {
    if (event) {
      this.optionWidth = this.mffContainer.nativeElement.getBoundingClientRect().width - 1;
    }
    this.openedChange.emit(event);
  }

  onValueChange($event, native?, selectElement?) {
    const val = native ? $event.target.value : $event.value;
    this.valueChange.emit(val);

    if (this.multiSelectMode || this.resetOnSelect) {
      this.value = null;
      selectElement.writeValue(null);
    } else {
      this.value = val;
      selectElement.writeValue(val);
    }
    this.cdr.detectChanges();
  }

  unsorted(a: KeyValue<string, string>, b: KeyValue<string, string>) {
    return 0;
  }

  changeSortMode(event) {
    event.stopPropagation();
    this.isAscendingChange.emit(!this.isSortAscending);
  }

  onOptionToggle(event, option) {
    if (this.deselectMode) {
      if (event.isUserInput && this.value === option.value) {
        this.value = null;
        this.valueChange.emit(null);
      }
    }
  }
}

export interface SelectionOption {
  key: string;
  value: any;
  img?: string;
}
